import { StdResponse, coreAxios, monixAxios } from "@/declare/api/axios"
import { AxiosResponse } from "axios";

/**
 * 获取项目中楼层列表，并根据标高排序
 */
export function findStoreysByProjectAndSortByElevation(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/storeys/groups`, {
        params: {
            ...params,
        },
    })
}

